const t = (e) => {
  switch (e) {
    case "align_center":
      return "center";
    case "align_left":
      return "flex-start";
    case "align_right":
      return "flex-end";
    default:
      return;
  }
};
export {
  t as alignTypeToJustifyContent
};
